import { AlertTriangle } from 'lucide-react';
import { Link } from 'react-router';
import { useActiveCertificates } from '@/features/cnpjs/hooks';

export function CertificateExpiryBanner() {
  const { certificates } = useActiveCertificates();
  const expiring = certificates
    .filter((c) => c.daysToExpire < 30)
    .sort((a, b) => a.daysToExpire - b.daysToExpire);

  if (expiring.length === 0) return null;
  const first = expiring[0];
  const message =
    expiring.length === 1
      ? `Certificado expira em ${first.daysToExpire} ${first.daysToExpire === 1 ? 'dia' : 'dias'}`
      : `${expiring.length} certificados expiram em menos de 30 dias`;

  return (
    <div
      role="alert"
      className="flex items-center gap-2 border-b border-red-400/40 bg-red-500/10 px-4 py-2 text-sm text-red-700 dark:text-red-300"
    >
      <AlertTriangle className="h-4 w-4" aria-hidden />
      <span className="flex-1">{message}. Renove antes para não bloquear emissão de NF.</span>
      <Link
        to="/certificates"
        className="font-medium underline hover:no-underline"
      >
        Gerenciar certificados
      </Link>
    </div>
  );
}
